import { render, staticRenderFns } from "./rubric_select.vue?vue&type=template&id=6a35841e&"
import script from "./rubric_select.vue?vue&type=script&lang=js&"
export * from "./rubric_select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports